{
  "enum": {
    "IxfAccountingV1AccountClassification": {
      "ASSET": "Asset",
      "EQUITY": "Equity",
      "EXPENSE": "Expense",
      "LIABILITY": "Liability",
      "REVENUE": "Revenue",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfAccountingV1AccountStatus": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfAccountingV1ConfigStatus": {
      "OPEN": "Open",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfAccountingV1ManualEntryStatus": {
      "CANCELED": "Canceled",
      "POSTED": "Posted",
      "REVERSED": "Reversed",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfAccountingV1TransactionStatus": {
      "CANCELED": "Canceled",
      "POSTED": "Posted",
      "REVERSED": "Reversed",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxfAccountingV1AccountQueryServiceAccountListFilterableFields": {
      "accountId": "Account",
      "data": {
        "classification": "Classification",
        "spec": {
          "number": "Number"
        }
      },
      "status": "Status"
    },
    "IxfAccountingV1ConfigQueryServiceConfigListFilterableFields": {
      "status": "Status"
    },
    "IxfAccountingV1ManualEntryQueryServiceManualEntryListFilterableFields": {
      "entryId": "Entry",
      "status": "Status"
    },
    "IxfAccountingV1TransactionQueryServiceTransactionListFilterableFields": {
      "data": {
        "date": "Date",
        "deltas": {
          "accountId": "Account"
        }
      },
      "status": "Status",
      "transactionId": "Transaction"
    }
  },
  "oneOf": {
    "IxfAccountingV1AccountEventType": {
      "accountCreated": "Account Created",
      "accountUpdated": "Account Updated",
      "activated": "Activated",
      "deactivated": "Deactivated",
      "setAccountCodes": "Set Account Codes"
    },
    "IxfAccountingV1ConfigEventType": {
      "init": "Init",
      "setLockOutDate": "Set Lock Out Date"
    },
    "IxfAccountingV1DeltasResponseTotals": {
      "permanent": "Permanent",
      "temporary": "Temporary"
    },
    "IxfAccountingV1ManualEntryEventType": {
      "attachmentAdded": "Attachment Added",
      "attachmentRemoved": "Attachment Removed",
      "canceled": "Canceled",
      "posted": "Posted",
      "reversed": "Reversed"
    },
    "IxfAccountingV1TransactionEventType": {
      "canceled": "Canceled",
      "posted": "Posted",
      "reversed": "Reversed"
    }
  },
  "polymorph": {
    "IxfAccountingV1TransactionDetail": {
      "exc": {
        "jpmam": {
          "v1": {
            "MoneyMarketTransaction": "Money Market"
          }
        }
      },
      "ixc": {
        "billing": {
          "v1": {
            "ChargeTransaction": "Charge",
            "CustomerChargeTransaction": "Customer Charge"
          }
        },
        "corpactions": {
          "caadmin": {
            "v1": {
              "DTCPaymentTransaction": "DTC Payment Transaction"
            }
          },
          "v1": {
            "CorpactionTransaction": "Corporate Action"
          }
        },
        "dtcc": {
          "cns": {
            "v1": {
              "SettlementTransaction": "Settlement"
            }
          }
        },
        "funding": {
          "v1": {
            "FundingBatchTransaction": "Funding Batch",
            "FundingTransaction": "Funding"
          }
        },
        "inventory": {
          "v1": {
            "CloseTradingDayTransaction": "Close Trading Day",
            "InventoryTradeTransaction": "Inventory Trade",
            "SettleTradingDayTransaction": "Settle Trading Day"
          }
        },
        "mutualfunds": {
          "v1": {
            "FundTransaction": "Fund Transaction"
          }
        },
        "orders": {
          "v1": {
            "BatchAllocationAvgPriceTransaction": "Batch Allocation Average Price",
            "BatchAllocationCustomerTransaction": "Batch Allocation Customer",
            "BatchRemainderInventoryTransaction": "Batch Remainder Inventory",
            "TradeTransaction": "Trade"
          }
        },
        "portfolio": {
          "v1": {
            "DividendPaymentTransaction": "Dividend"
          }
        },
        "ragl": {
          "v1": {
            "ManualTransaction": "Manual Entry"
          }
        },
        "sweeps": {
          "clearing": {
            "v1": {
              "SweepsTransaction": "Sweeps Transaction"
            }
          }
        },
        "trade": {
          "v1": {
            "NettingIndicationTransaction": "Netting Indication"
          }
        }
      },
      "ixf": {
        "accounting": {
          "v1": {
            "ManualEntryTransaction": "Manual Entry"
          }
        }
      }
    }
  },
  "searchEnum": {
    "IxfAccountingV1AccountQueryServiceAccountListSearchableFields": {
      "data": {
        "spec": {
          "label": "Label"
        }
      }
    }
  },
  "sortEnum": {
    "IxfAccountingV1AccountQueryServiceAccountListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxfAccountingV1ConfigQueryServiceConfigListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxfAccountingV1ManualEntryQueryServiceManualEntryListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxfAccountingV1TransactionQueryServiceTransactionListSortableFields": {
      "data": {
        "date": "Date"
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}